import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { column, report, reportCategory } from 'src/app/dashboards/models';
import { gridItem } from 'src/app/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';

@Component({
    selector: 'app-reports-basic-info',
    templateUrl: './reports-basic-info.component.html',
    styleUrls: ['./reports-basic-info.component.scss'],
    animations: [
        trigger('collapse', [
            state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
            state('true', style({ height: '0', visibility: 'hidden' })),
            transition('false => true', animate('200ms ease-in')),
            transition('true => false', animate('200ms ease-out'))
        ])
    ],
    standalone: false
})

export class ReportBasicInfoComponent implements OnInit {
  @Input() report: report = null;
  @Input() infoAllColumns: boolean;
  @Input() gridItem: gridItem;

  basicExpanded: boolean;
  reportCategories: Array<reportCategory>;
  filterTableInput: string = '';
  filteredTable: column[];

  constructor(protected dashboardsService: DashboardService, private i18nextPipe: I18NextPipe) { }
  ngOnInit(): void {
    let allCategories: reportCategory = { id: -1, category:  this.i18nextPipe.transform('dashboard:All Categories') , inUse: 1 };
    this.dashboardsService.getReportCategories().subscribe(rc => this.reportCategories = [...[allCategories], ...rc]);
    this.getColumnsFiltered();
  }

  getColumnsFiltered() {
    let cols = [];
    if (this.infoAllColumns) {
      cols = this.report?.allColumns;
    } else if (this.report.subReportId == 0) {
      cols = this.report?.allColumns.filter(c => this.report?.defaultColumns.includes(c.labelCode) || c.isKey);
    } else {
      cols = this.report?.allColumns.filter(c => this.gridItem.setup.columns.includes(c.labelCode));
    }
    if (this.filterTableInput && this.filterTableInput.trim().length > 0) {
      cols = cols.filter(c => c.shortDescription.toLowerCase().includes(this.filterTableInput.toLowerCase()) ||
        c.longDescription.toLowerCase().includes(this.filterTableInput.toLowerCase()));
      cols = cols.map(c => ({
        ...c,
        shortDescription: this.highlight(c.shortDescription, this.filterTableInput),
        longDescription: this.highlight(c.longDescription, this.filterTableInput)
      }));
    }
    this.filteredTable = cols || [];
  }

  escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  escapeHtml(str: string): string {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  highlight(text: string, search: string): string {
    if (!search) return this.escapeHtml(text);
    const safeText = this.escapeHtml(text);
    const safeSearch = this.escapeRegExp(search);
    const regex = new RegExp(safeSearch, "gi");
    return safeText.replace(regex, (match) => `<b>${match}</b>`);
  }
}
